import { render, staticRenderFns } from "./FlowElement.vue?vue&type=template&id=2c495bc6&scoped=true&"
import script from "./FlowElement.vue?vue&type=script&lang=js&"
export * from "./FlowElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c495bc6",
  null
  
)

export default component.exports